﻿import {EventEmitter} from "@angular/core";
import { ErrorAction, ErrorNotification, INotifyError  } from "./iNotifyError";
import { IValidate } from "./iValidate";
import { Observable,Observer } from "rxjs";
import { IncorrectFormat } from "./validationConstants";
import { ValidationMessage } from "./validationMessage";
import { ValidationMessageHelper } from "./validationMessageHelper";



export const ErrorObjName = "ErrorNotifier";

export class ValidationBase implements INotifyError, IValidate {

    private obs: Observer<boolean>;

    public get isValid() {
        return !this.validationMessages || this.validationMessages.length <= 0;
    }

    public get hasIncorrectFormat() {
        return this.validationMessages.filter(( s ) => s.message === IncorrectFormat).length > 0;
    }

    public validationChanged = new EventEmitter<boolean>();
    // INotifyError members
    public notifier = new EventEmitter<ErrorNotification>();

    public  validationMessages: ValidationMessage[] = [];

    public addValidationMessage(vm: ValidationMessage | ValidationMessage[], notify = true): void {
        if (Array.isArray(vm)) {
            vm.forEach(( s ) => this.add(s, notify));
        } else {
            this.add(vm, notify);
        }
        this.validationChanged.emit(this.validationMessages.length > 0);
    }

    public  removeValidationMessage(vm: ValidationMessage | ValidationMessage[], notify = true): void {
        if (!vm) {
            return;
        }
        if (Array.isArray(vm)) {
            vm.forEach(( s ) => this.remove(s, notify));
        } else {
            this.remove(vm, notify);
        }
        this.validationChanged.emit(this.validationMessages.length > 0);
    }

    public  clear() {
        this.validationMessages = [];
        this.notifyError(null, ErrorAction.Clear);
        this.validationChanged.emit(this.validationMessages.length > 0);
    }
    // INotifyError members ends
    // IValidate members
    public onValidate = new EventEmitter<any>();

    public validate(): Observable<boolean> {
        var observable = new Observable<boolean>((s) => {
            s.next(); 
           // this.obs = s;
        });
        this.onValidate.emit(null);
        return observable;
    }

    public beforeValidate(propName: string) {}

    public  afterValidate(message: ValidationMessage | ValidationMessage[]) { }

    public  validationCompleted() {
        if (this.obs) {
            this.obs.next(true);
            this.obs.complete();
        }
    }
    // IValidate members ends
    // static
    public static addValidationBaseToEntity(entity: any) {
        entity[ErrorObjName] = new ValidationBase();
    }
    // private
    private notifyError(vm: ValidationMessage, action: ErrorAction): void {
        this.notifier.next(new ErrorNotification(vm, action));
    }
    private add(vm: ValidationMessage, notify: boolean) {
        this.validationMessages.push(vm);
        if (notify) {
            this.notifyError(vm, ErrorAction.Added);
        }
    }
    private remove(vm: ValidationMessage, notify: boolean) {
        if (!this.validationMessages || this.validationMessages.length <= 0 || !vm) {
            return;
        }
        ValidationMessageHelper.removeMessage(this.validationMessages, vm);
        if (notify)
            this.notifyError(vm, ErrorAction.Removed);
    }
}
